

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const BULKUPLOADKRAKPIQUESTIONSFROMEXCEL= createAsyncThunk(
  "bulkUploadKraKpiQuestionsFromExcel/bulkUploadKraKpiQuestionsFromExcel",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const bulkUploadKraKpiQuestionsFromExcelSlice = createSlice({
  name: "bulkUploadKraKpiQuestionsFromExcelSlice",
  initialState: {
    bulkUploadKraKpiQuestionsFromExcel: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfbulkUploadKraKpiQuestionsFromExcel: (state) => {
        state.bulkUploadKraKpiQuestionsFromExcel.loading = false
        state.bulkUploadKraKpiQuestionsFromExcel.error = false
        state.bulkUploadKraKpiQuestionsFromExcel.data = []
        state.bulkUploadKraKpiQuestionsFromExcel.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(BULKUPLOADKRAKPIQUESTIONSFROMEXCEL.fulfilled, (state, action) => {
      state.bulkUploadKraKpiQuestionsFromExcel = {
        ...state.bulkUploadKraKpiQuestionsFromExcel,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(BULKUPLOADKRAKPIQUESTIONSFROMEXCEL.pending, (state, action) => {
      state.bulkUploadKraKpiQuestionsFromExcel = {
        ...state.bulkUploadKraKpiQuestionsFromExcel,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(BULKUPLOADKRAKPIQUESTIONSFROMEXCEL.rejected, (state, action) => {
      state.bulkUploadKraKpiQuestionsFromExcel = {
        ...state.bulkUploadKraKpiQuestionsFromExcel,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const bulkUploadKraKpiQuestionsFromExcelAction = {
    BULKUPLOADKRAKPIQUESTIONSFROMEXCEL,
};

export { bulkUploadKraKpiQuestionsFromExcelAction };
export default bulkUploadKraKpiQuestionsFromExcelSlice.reducer;
export const {setInitialStateOfbulkUploadKraKpiQuestionsFromExcel} = bulkUploadKraKpiQuestionsFromExcelSlice.actions
